export default __webpack_public_path__ + "static/media/backgroung.c2ba8fc2.png";